(function () {
  'use strict'

  require('./scss/glow-vote.scss')

  const MODULE_NAME = 'thismoment.glow.component.glow-vote'
  const templateUrl = require('./tpl/glow-vote.html')
  const modalTemplateUrl = require('./tpl/vote-modal.html')

  require('angular')
    .module(MODULE_NAME, [
      require('../../../common/formly/inputs/recaptcha'),
      require('../../../modal'),
      require('../glow-modal'),
      require('./provider/vote-api')
    ])
    .component('thismomentGlowVote', {
      templateUrl: templateUrl,
      controller: thismomentGlowVoteController,
      bindings: {
        item: '<',
        voteConfig: '=',
        trackEvent: '&'
      }
    })

  thismomentGlowVoteController.$inject = ['$scope', '$element', '$stateParams', 'analyticsSDK', 'VoteApi', 'Modal']
  function thismomentGlowVoteController ($scope, $element, $stateParams, analyticsSDK, VoteApi, Modal) {
    const vm = this

    vm.path = $stateParams.path
    vm.$onInit = voteInit
    vm.voteOnClick = launchGlowVote

    function voteInit () {
      vm.styles = {
        button: {
          'background-color': vm.voteConfig.voteButtonCtaColor,
          'color': vm.voteConfig.voteButtonCtaFontColor
        },
        modal: {
          'background-color': vm.voteConfig.voteButtonSubmitColor
        }
      }
    }

    function updateVoteState () {
      vm.voteConfig.votes[vm.item.id] = true
    }

    function launchGlowVote () {
      if (vm.item.id in vm.voteConfig.votes) {
        return false
      }
      vm.trackEvent = analyticsSDK.setupEventTracking({})
      vm.trackEvent('Content Converted', {
        'event trigger': 'initiated vote'
      })

      // modal settings
      $scope.ariaLabel = 'Vote for this content'
      $scope.cancelBackgroundColor = null
      $scope.cancelColor = null
      $scope.cancelText = 'Cancel'
      $scope.errorButtonText = 'Continue'
      $scope.errorColor = null
      $scope.errorDescription = 'Please try voting again.'
      $scope.errorTitle = 'Error'
      $scope.submissionBackgroundColor = null
      $scope.submissionBackgroundImage = null
      $scope.submissionFormDescription = null
      $scope.submissionFormDescriptionColor = null
      $scope.submissionFormTitle = null
      $scope.submissionFormTitleColor = null
      $scope.submitBackgroundColor = vm.voteConfig.voteButtonSubmitColor
      // $scope.submitColor = vm.voteConfig.voteButtonSubmitColor
      $scope.submitText = vm.voteConfig.voteButtonSubmitText
      $scope.successButtonText = 'Continue'
      // $scope.successColor = CartConfig.get('send_button_color')
      $scope.successDescription = null
      $scope.successTitle = 'Thank you'

      $scope.fields = [{
        key: 'recaptcha_token',
        type: 'recaptcha',
        templateOptions: {
          required: true,
          label: 'Verify Identify'
        }
      }]

      let expanded = Modal()
      expanded.open({
        animation: false,
        component: 'thismomentGlowModal',
        size: 'lg',
        resolve: {
          options: {
            // analytics
            trackEvent: vm.trackEvent,
            parentEvent: 'Glow Vote',
            parentType: 'Vote',
            // config
            getParentScope: getParentScope, // not using uib's $scope parameter as that does not play nicely
            onSubmit: onSubmit,
            templateUrl: modalTemplateUrl
          }
        }
      }, exitModal, exitModal)()

      function onSubmit (formData) {
        angular.extend(formData, {
          content_id: vm.item.id,
          glow_module_contest_id: vm.voteConfig.id,
          contest_user_id: vm.voteConfig.userId
        })
        return VoteApi.post(formData).then(function (response) {
          if (!response.hasOwnProperty('success')) {
            throw response
          }
          updateVoteState()
        })
      }

      function exitModal () {
        $element[0].focus() // use raw HTML element's `focus` method
      }

      function getParentScope () {
        return $scope
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-vote/index.js